import { Component, OnInit, trigger, state, style, transition, animate, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef } from '@angular/core';

import { DonneeService } from './../services/donnee.service';

//import { FirebaseApp } from 'angularfire2';

@Component({
  selector: 'cm-information',

  template: `
    <div class="ecran-information" 
        *ngIf="site"
        [@afficherCacherEcran]="etatEcran">

        <div class="cadre-fermer" (click)="fermer()"> <img class="img image-fermer" src="./assets/images/croix.png"/> </div>

        <div class="cadre-defilement" #cadreDefilement>
          <div class="cadre-titre">
            <div><h2>{{site.Nom}}</h2></div>
            <div (click)="ajouterFavoris(site)">
              <i *ngIf="!siteEstFavoris(site)"  class="fa fa-star-o etoile-favoris" aria-hidden="true"></i>
              <i *ngIf="siteEstFavoris(site)"  class="fa fa-star etoile-favoris" aria-hidden="true"></i>
              </div>
          </div>
          
          <div class="cadre-location">
            <img class="image-marqueur img" [src]="obtenirIconeMarqueur(site)"/>
            <h4> <span class="texte-location">{{site.Localisation}} </span> </h4>
          </div>

          <div class="cadre-evenement" [innerHTML]="remplacerImageEvenement(site)"></div>

          <hr>

          <div *ngIf="site.ImagePrincipale" class="cadre-image">
              <img class="img" [src]="obtenirImageSanctuaire(site)" />
          </div>

          <div innerHTML="{{remplacerLienExterne(site.Texte)}}"></div>

          <!--<hr>
          <div class="cadre-plus-info">
            <div><img src="./assets/images/plus.png" height="30px"></div>
            <div class="texte-plus-info"><h3>Plus d'infos</h3></div>
          </div>
          <div [innerHTML]="remplacerLienExterne(site.properties.name_link)"></div>-->

    </div>
  `,

  styles: [`
    .ecran-information {
        position: absolute;
        top: 0;
        left: 60vw;
        width: calc(40vw - 60px);
        height: calc(100vh - 50px);
        background-color: white;
        border: 1px solid lightgray;
    }
    .cadre-defilement {
        padding: 30px 30px 30px 45px;
        height: calc(100vh - 50px - 50px);
        overflow-y: auto;
    }
    h2 {
        font-weight: 700;
    }
    h4 {
      font-weight: 700;
    }
    .cadre-titre {
      display:flex;
      margin: 0px 0 10px 0;
    }
    .etoile-favoris {
      position: relative;
      top: 24px;
      left: 15px;
      cursor: pointer;
    }
    .fa {
      font-size: 26px;
      color: #FFA300;
    }
    .cadre-location {
      display: flex;
    }
    .texte-location {
      position: relative;
      top: -5px;
      left: 15px;
    }
    .cadre-evenement {
      margin-top: 20px;
      margin-bottom: 20px;
    }
    /deep/ .cadre-evenement img {
      margin-right: 5px;
    }
    /deep/ .cadre-image img {
      max-height: 30vh;
      max-width: 30vw;
      max-width: 100%;
    }
    .cadre-image {
      margin: 20px 0 20px 0;
      width: 100%;
    }
    .image-marqueur {
      height: 32px;
    }
    .cadre-plus-info {
      display: flex;
    }
    .texte-plus-info {
      position: relative;
      top: -18px;
      left: 15px;
    }
    .cadre-fermer {
      height: 50px;
    }
    .image-fermer {
      position: relative;
      top: 10px;
      left: calc(100% - 40px);
      width: 25px;
      height: 25px;
      cursor: pointer;
    }

    @media (max-width: 800px), (max-height: 700px) { 
        .ecran-information {
            left: 0;
            width: 100vw;
            height: 100vh;
            padding: 30px 20px 30px 20px;
        }
    }
  `],

  animations: [
    trigger('afficherCacherEcran', [
      state('visible', style({
        transform: 'translateX(0) scale(1, 1)'
      })),
      state('invisible', style({
        transform: 'translateX(100%) scale(0, 1)'
      })),
      transition('visible => invisible', animate('400ms ease-in-out')),
      transition('invisible => visible', animate('400ms ease-in-out'))
    ]),
  ]
})
export class InformationComponent implements OnInit, OnChanges {
  @Input() etatEcran: string;
  @Input() site: any;
  @Input() sitesFavoris: any[];
  @Output() fermerEcran: EventEmitter<any> = new EventEmitter();
  @ViewChild('cadreDefilement') private cadreDefilementDiv: ElementRef;

  constructor(
    private donneeService: DonneeService
  ) {}

  ngOnInit() {
  }

  ngOnChanges() {
    try {
      this.cadreDefilementDiv.nativeElement.scrollTop = 0;
    } catch(err) { }  
  }

  fermer() {
    this.fermerEcran.emit();
  }

  ajouterFavoris(site: any) {
    if (this.siteEstFavoris(site)) {
      this.enleverFavoris(site);
    } else {
      this.sitesFavoris.push(site);
    }
    this.donneeService.enregistrerIdFavoris(this.sitesFavoris);
  }

  siteEstFavoris(site: any) {
    for (const x in this.sitesFavoris) {
        if (this.sitesFavoris.hasOwnProperty(x) && this.sitesFavoris[x] === site) {
            return true;
        }
    }
    return false;
  }

  enleverFavoris(site: any) {
    let index = this.sitesFavoris.indexOf(site, 0);
    if (index > -1) {
      this.sitesFavoris.splice(index, 1);
    }
    this.donneeService.enregistrerIdFavoris(this.sitesFavoris);
  }

  obtenirImageSanctuaire(site: any) {
        if (site.ImagePrincipale) {
            return `./assets/ImageSite/${site.ImagePrincipale}`;
        } else {
            return '';
        }
    }

  remplacerLienExterne(html: string): string {
    return html.replace('<a href=', '<a target="_blank" href=');
  }

  remplacerImageEvenement(site: any) {
        let evenement = site.TypeEvenement.replace(/height="64"/g, 'height="30"');
        evenement = evenement.replace(/width="64"/g, 'width="30"');
        return evenement;
    }

  obtenirIconeMarqueur(site: any) {
       return './assets/images/' + site.TypeSite;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/information.component.ts